export const hasPrerequisitesAskSurvey = (question: string, answers: string[]): boolean =>
  question?.trim().length > 0
  && answers?.filter((answer) => answer?.trim().length > 0).filter(Boolean).length >= 2;
